<template>
  <div class="components-add-user-transfer">
    <myTransfer
            :show="true"
            v-model="selectList"
            :data="tableData"
            :options="options"
            @search="search"
            :placeholder="placeholder"
    >
      <!--分页区域-->
      <div class="page-pagination-wrapper">
        <el-pagination
                small
                v-show="paginationTotal"
                @current-change="getData"
                :current-page.sync="searchFormData.current"
                :page-size="searchFormData.size"
                layout="total, prev, pager, next"
                :pager-count="5"
                :total="paginationTotal">
        </el-pagination>
      </div>
    </myTransfer>
  </div>
</template>

<script>
    import myTransfer from './my-transfer'
    export default {
        name: "add-user-transfer",
        components: {
            myTransfer
        },
        props: {
            // 多余的参数
            extraParams: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            // 已选择list
            hasSelectList:{
                type: Array,
                default: () => {
                    return []
                }
            },
            placeholder: String
        },
        data(){
            return{
                searchFormData: {
                    condition: '',
                    size: this.$config.paginationSize,
                    current: 1
                },
                selectList: [],
                tableData: [],
                options: {
                    key: 'id',
                    colOptions: [{
                        label: '用户名',
                        key: 'name'
                    }, {
                        label: '用户账号',
                        key: 'username'
                    }, {
                        label: '组织架构',
                        key: 'organizationInfo'
                    }]
                },

                paginationTotal: 0
            }
        },
        watch: {
            extraParams(val){
                this.searchFormData = {
                    ...this.searchFormData,
                    ...val
                }
            },
            selectList(val) {
                this.$emit('input', val)
            },
        },
        created(){
            this.searchFormData = {
                ...this.searchFormData,
                ...this.extraParams,
            }
            this.search();
        },
        methods: {
            /**
             * 搜索
             */
            search(val){
                this.searchFormData.condition = val;
                this.searchFormData.current = 1;
                this.getData();
            },
            /**
             * 获取数据
             */
            getData(){
                this.$api.getUserShuttleList(this.searchFormData).then(res => {console.log(res,'aaaaaa')
                    this.tableData = res.body.records || [];
                    this.paginationTotal = res.body.total
                })
            },
        }
    }
</script>

<style scoped>
  .page-pagination-wrapper{
    padding: 8px 0;
  }
</style>
